<template>
    <div class="container-fluid">

        <div class="content" ref="content">

            <div class="container">
                
                <div class="row justify-content-lg-center">

                    <div class="col-lg-8">
                        <search/>             
                    </div>

                </div>

            </div>

            <div class="arrow-down">
                 <font-awesome-icon :icon="[ 'fas', 'arrow-alt-circle-down' ]" />
            </div>           

        </div> 
    </div>
</template>

<script>


export default {
    
    data(){
        return{
            range: true,
            shortcurts: false,
            today: new Date(),
            dayOfWeek: 1,
            time1: '',
            time2: '',
            time3: '',
            // custom lang
            lang: {
                days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],                
                placeholder: {
                    date: 'Select Date',
                    dateRange: 'Select Date Range'
                }
            }
        }
    },
    mounted() {
        this.$refs.content.style.height = window.innerHeight + "px";
    },
}
</script>

<style scoped>
    .container-fluid{
        margin: 0;
        padding: 0;
    }

    .mx-calendar-icon{
        color: #F00!important;
    }
    .arrow-down{
        position:fixed;
        bottom: 0;
        font-size:66px;
        color: #FFF;
        width: 100%;
        text-align:center;
    }

    .arrow-down:hover{
        color: #662483;
    }    

    .content{
        background-image: url('../assets/bgr-jumbonew.png'); 
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;       
    }
</style>